import { render, staticRenderFns } from "./page-content-type-page_content_group.vue?vue&type=template&id=bab6477e&scoped=true"
import script from "./page-content-type-page_content_group.vue?vue&type=script&lang=js"
export * from "./page-content-type-page_content_group.vue?vue&type=script&lang=js"
import style0 from "./page-content-type-page_content_group.vue?vue&type=style&index=0&id=bab6477e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab6477e",
  null
  
)

export default component.exports